import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { isDefined } from '@/components/sg-design-system/utils/index.ts';
import type { TargetAccuType } from '@/store/targetAccumulator/state.ts';

const AccuType = () => {
  const accuType = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.accuType ?? 'TargetAccu',
  );
  const accuTypeList = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.accuTypeList);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleAccuType = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Accumulator type changed',
      isDefined(event.target.value) ? event.target.value : 'cleared',
    );

    const selectedAccuType = event.target.value as TargetAccuType;
    switch (accuType) {
      case 'EKI': {
        await checkTargetAccumulatorWithTradeCapture({ ekiTrigger: null, accuType });
        break;
      }
      case 'PIVOT': {
        await checkTargetAccumulatorWithTradeCapture({
          strikeDown: null,
          pivot: null,
          strikeUp: null,
          accuType,
        });
        break;
      }
      case 'PIVOTEKI': {
        await checkTargetAccumulatorWithTradeCapture({
          ekiDown: null,
          strikeDown: null,
          pivot: null,
          strikeUp: null,
          ekiUp: null,
          accuType,
        });
        break;
      }
    }

    return checkTargetAccumulatorWithTradeCapture({
      accuType: selectedAccuType,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.accuType">
      <Form.Select value={accuType} onChange={handleAccuType} size="sm" data-e2e="accu-type-selector">
        {accuTypeList?.map((mode) => (
          <option key={mode} value={mode}>
            <FormattedMessage id={`targetAccumulator.form.accuType.${mode}`} />
          </option>
        ))}
      </Form.Select>
    </TargetAccumulatorFormField>
  );
};

export default AccuType;
